export enum SessionStorageItems {
  NewSQLConsoleQuery = 'new-sql-console:v1',
  SQLConsoleQuery = 'sql-console:v1',
  UtmSource = 'utm_source:v1',
}
